import StatusBadge from "../../components/common/StatusBadge";

const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "Name",
    dataIndex: "userDetails",
    render: defaultRender,
  },
  {
    title: "Domain Name",
    dataIndex: "domainName",
    render: defaultRender,
  },
  {
    title: "License Name",
    dataIndex: "licenseName",
    render: defaultRender,
  },
  {
    title: "Business Logo",
    dataIndex: "businessLogo",
    render: defaultRender,
    width : 120,
  },
  {
    title: "URL",
    dataIndex: "url",
    render: defaultRender,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    render: defaultRender,
  },
];

export default columns;
